import Service from "../../../Services/index";
import moment from "moment"

const AdvancePayment = {
    namespaced: true,
    state: {
        AdvancePaymentList:[],
        form:{
            id: "",
            employee: "",
            employee_id:"",
            employee_name:"",
            total_advance_payment: "",
            amount_return_per_month:"",
            paid_period: "",
        },
        search:{
            employee:"",
            employee_id:"",
            date:"",
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
    },
    mutations: {
        GET_ADVANCE_PAYMENT:(state,res)=>{
            state.AdvancePaymentList = res.data;
            state.dataPaginate = {
                current_page : res.current_page,
                from : res.form,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            };
        },
        GET_ADVANCE_PAYMENT_BY_ID:(state,res)=>{
            state.form = res;
        },
        CLEAR_FORM_DATA : state=>{
            state.form = {
                id: "",
                employee: "",
                employee_id:"",
                employee_name:"",
                total_advance_payment: "",
                amount_return_per_month:"",
                paid_period: "",
            };
        },
        CLEAR_SEARCH : state=>{
            state.search = {
                employee:"",
                employee_id:"",
                date:"",
            };
        },
    },
    actions: {
        setAdvancePayment({commit},page=1){
            return Service.AdvancePayment.getAdvancePayment(page).then(data=>{
                commit("GET_ADVANCE_PAYMENT",data);
            })
        },
        showAdvancePaymentById({commit},id){
            return Service.AdvancePayment.showAdvancePayment(id).then(res=>{
                commit("GET_ADVANCE_PAYMENT_BY_ID",res);
            })
        },
        saveAdvancePayment({commit},{id,data}){
            if(!id){
                return Service.AdvancePayment.createAdvancePayment(data).then(res=>{
                    console.log('create');
                });
            }else{
                return Service.AdvancePayment.updateAdvancePayment(id,data).then(res=>{
                    console.log('update');
                });
            }
        },
        deleteAdvancePayment(id){
            return Service.AdvancePayment.deleteAdvancePayment(id);
        },
        search({commit},data){
            return Service.AdvancePayment.searchAdvancePayment(data).then(res=>{
                commit("GET_ADVANCE_PAYMENT",res)
            })
        },
        clearFormData({ commit }) {
            commit("CLEAR_FORM_DATA");
        },
        clearSearch({ commit }) {
            commit("CLEAR_SEARCH");
        },
    }
};
export default AdvancePayment;
